// import React from 'react';
// import ReactDOM from 'react-dom';
// import './graphModal.scss';

// const GraphModal = ({ isOpen, onClose, title, children }) => {
//     if (!isOpen) return null;

//     return ReactDOM.createPortal(
//         <div className="graph-modal-overlay" onClick={onClose}>
//             <div className="graph-modal fullscreen" onClick={(e) => e.stopPropagation()}>
//                 <div className="graph-modal-header">
//                     {title && <h2 className="graph-modal-title">{title}</h2>}
//                     <button className="close-button" onClick={onClose}>
//                         &times;
//                     </button>
//                 </div>
//                 <div className="graph-modal-content">
//                     {children}
//                 </div>
//             </div>
//         </div>,
//         document.body
//     );
// };

// export default GraphModal;



import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import './graphModal.scss';

const GraphModal = ({
    isOpen,
    onClose,
    title,
    children,
    additionalContent,
    fullScreen = true,
    closeOnOverlayClick = true
}) => {
    const modalRef = useRef(null);
    const lastFocusedElement = useRef(null);

    // Handle accessibility and keyboard events
    useEffect(() => {
        if (!isOpen) return;

        lastFocusedElement.current = document.activeElement;

        const handleKeyDown = (e) => {
            if (e.key === 'Escape') onClose();
            if (e.key === 'Tab') trapFocus(e);
        };

        document.addEventListener('keydown', handleKeyDown);
        document.body.classList.add('modal-open');

        // Set initial focus
        modalRef.current.focus();

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.body.classList.remove('modal-open');
            lastFocusedElement.current?.focus();
        };
    }, [isOpen, onClose]);

    // Trap focus inside modal
    const trapFocus = (e) => {
        const focusableElements = modalRef.current.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (e.shiftKey && document.activeElement === firstElement) {
            lastElement.focus();
            e.preventDefault();
        } else if (!e.shiftKey && document.activeElement === lastElement) {
            firstElement.focus();
            e.preventDefault();
        }
    };

    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div
            className="graph-modal-overlay"
            onClick={closeOnOverlayClick ? onClose : null}
            data-testid="modal-overlay"
        >
            <div
                ref={modalRef}
                className={`graph-modal ${fullScreen ? 'fullscreen' : 'centered'}`}
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
                aria-labelledby="graph-modal-title"
                tabIndex={-1}
            >
                <div className="graph-modal-header">
                    {title && (
                        <h2
                            id="graph-modal-title"
                            className="graph-modal-title"
                        >
                            {title}
                        </h2>
                    )}
                    <button
                        className="close-button"
                        onClick={onClose}
                        aria-label="Close modal"
                        data-testid="close-button"
                    >
                        &times;
                    </button>
                </div>
                {/* Render additional content (legend) if provided */}
                {additionalContent && (
                    <div className="modal-legend">
                        {additionalContent}
                    </div>
                )}
                <div className="graph-modal-content">
                    {children}
                </div>
            </div>
        </div>,
        document.body
    );
};

export default GraphModal;